import { Model } from '@/models/Model';
export class Lvs extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'Lvs';
        this.$endpoint = '/lvs';
        this.$fillable = [];
    }
}
